const BASE_URL = process.env.REACT_APP_FAICON_APP_URL;
const TOKEN = process.env.REACT_APP_FAICON_APP_TOKEN;
export const fetchFaiconEvents = async () => {
  try {
    if (!TOKEN) {
      throw new Error("No API token found");
    }
    const response = await fetch(`${BASE_URL}/events/all/?sort_by=name&sort_type=asc&limit=1000`, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": `${TOKEN}`,
      },
    });
    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error fetching faicon events:", error);
    return [];
  }
};

export const fetchFaiconSessions = async (eventId) => {
  try {
    if (!TOKEN) {
      throw new Error("No API token found");
    }
    const response = await fetch(`${BASE_URL}/events/${eventId}/sessions/`, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": `${TOKEN}`,
      },
    });
    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error fetching faicon sessions:", error);
    return [];
  }
};